<template>
  <page
    v-if="loaded"
    :custom-style="{
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      paddingBottom: '50px'
    }"
  >
    <!-- 提示 -->
    <van-notice-bar
      v-if="noticeTip"
      wrapable
      :scrollable="false"
      color="#ff9600"
      left-icon="warning-o"
      :text="noticeTip"
    />
    <empty
      v-if="exportList.length === 0"
      :desc="'暂无导出列表'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
    <div v-else class="export-list">
      <div
        v-for="(item, exportIndex) in exportList"
        :key="'export' + exportIndex"
        class="export-item"
      >
        <p class="time">{{ item.dateStr }}</p>
        <div
          v-for="(detail, comapnyIdex) in item.detailList"
          :key="'company' + comapnyIdex"
          class="company-item"
        >
          <div class="name-wrapper">
            <div class="company-name">{{ detail.companyName }}</div>
            <div
              :class="[
                'status',
                {
                  valid: detail.status == 3
                }
              ]"
            >
              {{ getStatusName(detail) }}
            </div>
          </div>
          <div class="delivey-time">
            {{ getTimeText(detail) }} {{ detail.exportPeriod }}
          </div>
          <div class="delivery-wrapper">
            <div>导出方式：{{ getExportType(detail) }}</div>
            <div v-if="showBtn(detail)" class="btn" @click="downClick(detail)">
              下载
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import Empty from '@/common/layout/empty/index'
// import { checkAppVersion } from '@/utils/native_interactions/native_redirect'
// import { SYSTEM_SHARE_APP_VERSION } from '@/utils/native_interactions/const/version'
// import { appKey } from '@/defines/environment'
import { API } from '@/api'
import { Bridge } from '@mc/mc-jsbridge'
import {
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform'
export default {
  components: {
    Empty
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const title = '导出列表'
      navBar.setTitle({
        text: title
      })
      document.title = title
      vm.selected_company_id = to.query?.selected_company_id || ''
      vm.billExportList()
    })
  },
  data() {
    return {
      noticeTip: '',
      exportList: [],
      browerInfo: window.matrix,
      selected_company_id: '',
      loaded: false,
      isMCMallKeyCustomer:
        isMCMallKeyCustomerIOS() || isMCMallKeyCustomerAndroid()
    }
  },
  computed: {
    isApp() {
      return this.browerInfo.isMallApp || this.isMCMallKeyCustomer
    }
  },
  methods: {
    async billExportList() {
      this.$Loading()
      const res = await API.tpPay.exportList()
      this.noticeTip = res?.tip || ''
      this.exportList = res?.list || []
      this.loaded = true
      this.$Loading.hide()
    },
    downClick(detail) {
      this.$track(this.$trackMap.bill.exportListBtnClick)
      if (this.browerInfo.isMiniProgram) {
        return this.$dialog.alert({
          message: '小程序不支持下载，请去APP端下载'
        })
      } else {
        const shareInfo = {
          fileURL: detail.filePath,
          fileName: detail.fileName
        }
        Bridge.call('systemShare', shareInfo, res => {
          if (res.ret) {
            this.$Dialog.alert('下载成功')
          } else {
            this.$Dialog.alert('下载失败')
          }
        })
        // if (!checkAppVersion(SYSTEM_SHARE_APP_VERSION) && appKey === 'mall') {
        //   return this.$dialog.alert({
        //     message: '请下载最新版本APP进行手机文件导出'
        //   })
        // }
      }
    },
    getStatusName(detail) {
      // eslint-disable-next-line eqeqeq
      if (detail.exportType == 1) {
        // eslint-disable-next-line eqeqeq
        if (detail.status == 3) {
          return '已发送'
        } else if (!detail.status) {
          return '发送失败'
        }
        return '发送中'
        // eslint-disable-next-line eqeqeq
      } else if (detail.exportType == 2) {
        // eslint-disable-next-line eqeqeq
        if (detail.status == 3) {
          return '已导出'
        } else if (!detail.status) {
          return '导出失败'
        }
        return '导出中'
      }
    },
    getExportType(detail) {
      const map = {
        1: '发送到邮箱',
        2: '下载'
      }
      return map[detail.exportType]
    },
    getTimeText(detail) {
      const map = {
        1: '下单时间：',
        2: '配送时间：'
      }
      return map[detail.queryType]
    },
    showBtn(detail) {
      const canDown =
        // eslint-disable-next-line eqeqeq
        detail.exportType == 2 &&
        // eslint-disable-next-line eqeqeq
        detail.status == 3 &&
        (this.isApp || this.browerInfo.isMiniProgram)
      return canDown
    }
  }
}
</script>
<style lang="scss" scoped>
.empty-box {
  position: relative;
  top: 4rem /* 200/50 */;
}
.export-list {
  padding: 0 0.24rem /* 12/50 */;
  .export-item {
    padding-top: 0.16rem /* 8/50 */;
    @include text(0.24rem /* 12/50 */, #8c8c8c);
    .time {
      padding-bottom: 0.16rem /* 8/50 */;
    }
    .company-item {
      padding: 0.24rem /* 12/50 */ 0.16rem /* 8/50 */;
      margin-bottom: 0.16rem /* 8/50 */;
      background-color: #fff;
      border-radius: 0.24rem /* 12/50 */;
      @include text(0.28rem /* 14/50 */, #262626);
      .name-wrapper {
        @include flex-row-between;
        .company-name {
          flex: auto;
          width: 0;
          @include text-overflow-ellipsis;
        }
        .status {
          @include text(0.28rem /* 14/50 */, #8c8c8c);
          margin-left: 0.2rem /* 10/50 */;
          &.valid {
            color: #15bb5c;
          }
        }
      }
      .delivey-time {
        margin: 12px 0;
      }
      .delivery-wrapper {
        @include flex-row-between;
        .btn {
          @include flex-row-center;
          width: 1.12rem /* 56/50 */;
          height: 0.48rem /* 24/50 */;
          border-radius: 0.8rem /* 40/50 */;
          background-color: #15bb5c;
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
